export enum LANGUAGE {
	EN = 'en',
	TC = 'tc',
	SC = 'sc'
}
